/******** report.js ********** */
// imported into main.js
// functions for submitting data to api
// apply returned data to report template

import { formatTrimmedCurrency, removeItem } from "./utils.js";
//import { trimPrice } from './utils.js';
//import { stripFirstWord } from './utils.js';

const xhttp = new XMLHttpRequest(),
  //dataURL = "https://interactives.stuff.co.nz/api/sweet_spot",
  //dataURL = "http://34.116.97.42:8080/",
  dataURL = "https://interactives.stuff.co.nz/api/sweet_spot",

  //dataURL = "https://interactives.stuff.co.nz/temp-testing/john/ssdata-test/test1-2022.json",
  //jsonpURL = "https://interactives.stuff.co.nz/temp-testing/john/ssdata-test/test1-2022.jsonp",
  jsonpURL = "https://interactives.stuff.co.nz/temp-testing/john/ssdata-test/test2.jsonp",
  googleKey = "AIzaSyBi7Po2jeXGEg9I4aidgjN_PQKV0ta1MWM";

let useJsonP = window.useJsonP; // copy useJsonP variable from global scope  - set in index.html

// if we need to use jsonp
// define and export callback for jsonp
// jsonp used for local testing
let json_cb = (obj) => {
  let jsonData = JSON.parse(JSON.stringify(obj));
  showReport(jsonData);
};

// injects function to call jsonp data
// gets added to global scope
const getJsonP = (str) => {
  let js = document.createElement("script");
  js.src = jsonpURL + str;
  document.body.appendChild(js);
};

const submitData = (str) => {
  let dataStr = str;
  console.log(str);

  if (!useJsonP) {
    //when using a simple GET request - not jsonp //
    xhttp.open("GET", dataURL + dataStr, true);
    xhttp.onreadystatechange = function () {
      console.log(this.status);
      if (this.readyState === 4 && this.status === 200) {
        //console.log(xhttp.responseText);
        let jsonData = JSON.parse(xhttp.responseText);

        showReport(jsonData);
      } else {
        console.log("there was an error: " + this.status);
      }
    };
    xhttp.send();
  } else {
    /// IF jsonp needed ///
    dataStr += "&callback=json_cb";
    getJsonP(dataStr);
  }
};

// show report of chosen sweet spot
const showReport = (data) => {
  let scrollTarget = document.querySelector("#scrollTarget");
  // removeItem(document.querySelector("#ss-current")); // remove suburb selection from display
  // removeItem(document.querySelector("#ss-limits")); //remove limits selection from display
  // removeItem(document.querySelector("#ss-sweet")); // remove criteria selection from display
  // hide criteria before showing report
  // but keep for possible refinement
  const criteriaContainer = document.querySelector('#ss-criteria');
  criteriaContainer.style.display = 'none';
  let interactive = document.querySelector("#ss-interactive");
  let ssReport = document.createElement("section");
  let reportPartOne = document.createElement("div");
  let reportMapNote = document.createElement("div");
  let reportPartTwo = document.createElement("div");
  let reportPartTable = document.createElement("div");
  let ss = data[0].sweet; // sweet-spot data
  let cur = data[1].curr; // current suburb data
  let lng = ss.lon;
  let lat = ss.lat;
  let reportTemplateOne = `
    <div class="ss-section-head ss-reportHead">
      <div class="ss-pin"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.4 41.5"><defs><style>.tick{fill:none;stroke:#ae0035;stroke-linejoin:bevel;stroke-width:7px;}</style></defs><polyline class="tick" points="2.85 25.43 12.86 39.47 39.56 2.03"/></svg></div>
      <div class="ss-headtext">
      <h3>Your Sweet Spot</h3>
      <p>You've found a Sweet Spot: <strong>${ss.suburb_name}!</strong></p>
      </div>
    </div>
    <p>${ss.suburb_name} is located within ${ss.ta} boundaries and is a ${ss.density_phrase} area with ${ss.age_phrase} population. The median age is ${ss.median_age}.</p>

    <p>${ss.suburb_name} receives ${ss.sunshine_phrase} sunshine ${ss.coast_phrase}. It has a ${ss.volunteer_phrase} rate of community volunteering. The crime rate is ${ss.crime_phrase}. Essential services such as supermarkets and hospitals ${ss.access_phrase}. The closest primary school is ${ss.primary_phrase} walk away and the nearest secondary school is ${ss.secondary_phrase} drive away.</p>

    <p>It ${ss.diversity_phrase} New Zealand as a whole. About ${ss.maori_ancestry_pc} per cent of people in ${ss.suburb_name} have some whakapapa M&#257;ori. There is ${ss.kura_phrase} kura kaupapa or other M&#257;ori-medium schooling within or near the area.</p>

    <p>${ss.suburb_name} has ${ss.pt_phrase} rates of public transport or people walking, cycling and scooting to work and education. Employment rates are ${ss.employment_phrase}, and the overall economic prosperity of the area has ${ss.prosperity_phrase} in recent years. Per square kilometre there are ${ss.hospo_phrase}.</p>`;

  let reportTemplateTwo = `<h4>Thinking about buying in ${ss.suburb_name}?</h4>

    <p>The median house price there in the three months to May 2022 was ${formatTrimmedCurrency(
      ss.price_phrase
    )}, which is ${ss.median_phrase} the rest of ${
    ss.region_phrase
  }. Prices in this area have ${ss.change_phrase} by ${
    ss.suburb_six_mth_change
  }% in the last six months. The average section size here is ${
    ss.section_phrase
  }.</p>

    <p>The average weekly rent in ${ss.suburb_name} is ${
    ss.rent_phrase
  }, which is ${ss.rent_mean_phrase} other areas in the region.</p>

    <h4>How does that shape up against where you live now?</h4>`;

  let compareTable = `<table class="ss-compareTable">
    <tr><th>&nbsp;</th><th>Current</th><th>Sweet Spot</th></tr>
    <tr><td class="ss-feature">Location</td><td>${cur.suburb_name}<br>${
    cur.ta
  }</td><td>${ss.suburb_name}<br>${ss.ta}</td></tr>
    <tr><td class="ss-feature">Median age</td><td>${cur.median_age}</td><td>${
    ss.median_age
  }</td></tr>
    <tr><td class="ss-feature">Travel time to nearest supermarket</td><td>${
      cur.supermarket_distance
    } minutes</td><td>${ss.supermarket_distance} minutes</td></tr>
    <tr><td class="ss-feature">Travel time to nearest hospital</td><td>${
      cur.hospital_distance
    } minutes</td><td>${ss.hospital_distance} minutes</td></tr>
    <tr><td class="ss-feature">Walking distance to nearest primary school</td><td>${
      cur.primary_phrase
    }</td><td>${ss.primary_phrase}</td></tr>
    <tr><td class="ss-feature">Travel time to nearest secondary school</td><td>${
      cur.secondary_phrase
    }</td><td>${ss.secondary_phrase}</td></tr>
    <tr><td class="ss-feature">Volunteer level</td><td>${
      cur.volunteer_phrase
    }</td><td>${ss.volunteer_phrase}</td></tr>
    <tr><td class="ss-feature">Crime level</td><td>${
      cur.crime_phrase
    }</td><td>${ss.crime_phrase}</td></tr>
    <tr><td class="ss-feature">Diversity</td><td>${
      cur.diversity_phrase
    } NZ as a whole</td><td>${ss.diversity_phrase} NZ as a whole</td></tr>
    <tr><td class="ss-feature">People with whakapapa M&#257;ori</td><td>${
      cur.maori_ancestry_pc
    }%</td><td>${ss.maori_ancestry_pc}%</td></tr>
    <tr><td class="ss-feature">Employment</td><td>${
      cur.employment_phrase
    }</td><td>${ss.employment_phrase}</td></tr>
    <tr><td class="ss-feature">Prosperity</td><td>${
      cur.prosperity_phrase
    }</td><td>${ss.prosperity_phrase}</td></tr>
    <tr><td class="ss-feature">Public or active transport use</td><td>${
      cur.pt_phrase
    }</td><td>${ss.pt_phrase}</td></tr>
    <tr><td class="ss-feature">Cafes, restaurants and bars</td><td>${
      cur.hospo_phrase
    }</td><td>${ss.hospo_phrase}</td></tr>
    <tr><td class="ss-feature">Sunshine</td><td>${
      cur.sunshine_phrase
    }</td><td>${ss.sunshine_phrase}</td></tr>
    <tr><td class="ss-feature">Median house price</td><td>${formatTrimmedCurrency(
      cur.price_phrase
    )}</td><td>${formatTrimmedCurrency(ss.price_phrase)}</td></tr>
    <tr><td class="ss-feature">Average weekly rent</td><td>${
      cur.rent_phrase
    }</td><td>${ss.rent_phrase}</td></tr>
    </table>`;

  ssReport.classList.add("ss-section");
  ssReport.classList.add("ss-report");
  reportPartOne.id = "report-p1";
  reportPartOne.innerHTML = reportTemplateOne;
  reportPartTwo.innerHTML = reportTemplateTwo;
  reportPartTwo.id = "report-p2";
  reportPartTable.innerHTML = compareTable;
  reportPartTable.id = "report-table";

  ssReport.appendChild(reportPartOne);

  /*********************** */
  /******** MAP SETUP ****** */
  let ssMapContainer = document.createElement("div");

  ssMapContainer.id = "ssMap";
  ssMapContainer.classList.add("ss-map");
  ssReport.appendChild(ssMapContainer);

  /***** GOOGLE iframed map  */

  let gmap = document.createElement("iframe"),
    placeName = encodeURI(`${ss.suburb_name}, ${ss.ta}`);

  gmap.setAttribute("frameborder", "0");
  gmap.setAttribute("width", "100%");
  gmap.setAttribute("height", "270px");
  gmap.style.border = "0";
  gmap.src = `https://www.google.com/maps/embed/v1/place?key=${googleKey}&q=${placeName}&center=${lat},${lng}&zoom=12&maptype=roadmap`;

  ssMapContainer.appendChild(gmap);
  /***************************************** */

  reportMapNote.innerHTML =
    "Rural locations may include an area beyond the nearest township and so locations are approximate";
  reportMapNote.classList.add("ss-mapNote");

  ssReport.appendChild(reportMapNote);
  ssReport.appendChild(reportPartTwo);
  ssReport.appendChild(reportPartTable);

  interactive.appendChild(ssReport);

  // scroll page to top of report
  scrollTarget.style.paddingBottom = "60px";
  scrollTarget.scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "nearest",
  });

  //create and display button container
  let btnHolder = document.createElement("div");
  btnHolder.classList.add("ss-resetBtns");
  ssReport.appendChild(btnHolder);

  // create and display a refine search button
  let refineBtn = document.createElement("div");
  refineBtn.classList.add("ss-actionBtn");
  //refineBtn.classList.add("ss-resetBtn");
  refineBtn.innerText = "Refine search";
  btnHolder.appendChild(refineBtn);

  // create and display a reset button
  let resetBtn = document.createElement("div");
  resetBtn.classList.add("ss-actionBtn");
  //resetBtn.classList.add("ss-resetBtn");
  resetBtn.innerText = "Choose again";
  btnHolder.appendChild(resetBtn);

  refineBtn.addEventListener("click", () => {
    //remove report and redispplay previous selections
    removeItem(ssReport);
    criteriaContainer.style.display = 'block';
    scrollTarget.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  });

  resetBtn.addEventListener("click", () => {
    window.location.reload();
  });
};

export { submitData, json_cb };
